import { Divider, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import SummaryStatsRow from '~/components/Statistics/SummaryStatsRow';
import {
    formatDisplayIntensity,
    imageIntensityUnit,
    toDisplayIntensity,
} from '~/domain/dicom/intensityUnits';
import { CircleRegion } from '~/domain/intensity/circleRegion';
import { Image3D } from '~/domain/patient/image3d';

/**
 * The selected circle's min, max, mean and SD, below the list, in the image's
 * unit. One unit fits all four because the display conversion is a plain
 * scale factor, so it applies to the SD too. Without the image there is no
 * unit or scale, so the figures are not shown.
 */
export default function CircleRegionDetail({
    circle,
    image,
}: {
    circle: CircleRegion;
    image: Image3D | undefined;
}) {
    const intl = useIntl();
    const format = (value: number): string =>
        formatDisplayIntensity(toDisplayIntensity(value, image), '');
    const unavailableId = image
        ? 'circleRegion.noStats'
        : 'circleRegion.noImage';
    return (
        <>
            <Divider sx={{ my: 0.5 }} />
            {image && circle.stats ? (
                <SummaryStatsRow
                    stats={circle.stats}
                    format={format}
                    unit={imageIntensityUnit(image)}
                />
            ) : (
                <Typography
                    variant="caption"
                    sx={{ display: 'block', color: 'text.secondary' }}
                >
                    {intl.formatMessage({ id: unavailableId })}
                </Typography>
            )}
        </>
    );
}
